import AdminDashboardPage from '../pages/AdminDashboardPage'
import AdminProfilePage from '../pages/AdminProfilePage'
import { useAdminAuth } from '../providers/AdminAuthProvider'

export function DefaultRoute() {
  const { hasPermission } = useAdminAuth()

  // If user has dashboard permission, show dashboard
  if (hasPermission('view_dashboard')) {
    return <AdminDashboardPage />
  }

  // Otherwise, show profile page
  return <AdminProfilePage />
}
